module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.1.1Rc.11 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/actionsheet.html"
    }
  }, [_vm._v("Actionsheet")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 更加流畅的遮罩层动画")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/alert.html"
    }
  }, [_vm._v("Alert")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 作为插件使用时，每次都重置属性值")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/confirm.html"
    }
  }, [_vm._v("Confirm")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复插件代码里的值和事件监听器")]), _vm._v(" "), _c('li', [_vm._v("[fix] 以插件方式显示时强制重置数据")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/datetime.html"
    }
  }, [_vm._v("Datetime")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持格式化显示 prop:display-format #1086 @greedying")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/loading.html"
    }
  }, [_vm._v("Loading")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 以插件形式使用时强制重置属性值")]), _vm._v(" "), _c('li', [_vm._v("[enhance] 添加渐现动画")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup-picker.html"
    }
  }, [_vm._v("PopupPicker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 修复 Safari 下遮罩层渲染慢的问题 #1083 @sixiakun")]), _vm._v(" "), _c('li', [_vm._v("[enhance] 默认开启 transfer-dom，解决非 Safari 也会出现的 z-index 问题")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup.html"
    }
  }, [_vm._v("Popup")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复遮罩禁用点击时错误设置 overflowScrolling 的问题")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-dialog.html"
    }
  }, [_vm._v("XDialog")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 更流畅的遮罩动画和弹窗动画")]), _vm._v(" "), _c('li', [_vm._v("[enhance] 添加 dom 转移到 body 下的 demo")]), _vm._v(" "), _c('li', [_vm._v("[enhance] 移除无用代码")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-textarea.html"
    }
  }, [_vm._v("XTextarea")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持 on-focus on-blur 事件 #1082 @zeusLeeJh")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-760957a5", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-760957a5"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.1.1-rc.11-206.vue
// module id = 2341
// module chunks = 357